import { Component, computed, input, output } from '@angular/core';

import { AdminsAvatarsComponent } from '@core/account-ui';
import type { RatingScale } from '@core/candidate-evaluation-settings-types';
import type { AggregatedEvaluationsSummary } from '@core/evaluations-types';
import { TranslatePipe } from '@core/i18n-legacy';
import { Theme } from '@core/theme-util';
import { TimeAgoPipe } from '@core/time-legacy';
import {
  ButtonComponent,
  CollapsibleCardComponent,
  HeadingComponent,
  IconComponent,
} from '@core/user-interface-legacy';

import { CandidateRatingsScoreChartComponent } from '../candidate-ratings-score-chart/candidate-ratings-score-chart.component';
import { CandidateSkillsChartComponent } from '../candidate-skills-chart/candidate-skills-chart.component';

@Component({
  selector: 'rt-candidate-offer-evaluation-summary',
  templateUrl: './candidate-offer-evaluation-summary.component.html',
  styleUrl: './candidate-offer-evaluation-summary.component.less',
  imports: [
    AdminsAvatarsComponent,
    ButtonComponent,
    CandidateRatingsScoreChartComponent,
    CandidateSkillsChartComponent,
    CollapsibleCardComponent,
    HeadingComponent,
    IconComponent,
    TimeAgoPipe,
    TranslatePipe,
  ],
})
export class CandidateOfferEvaluationSummaryComponent {
  protected readonly hasSingleChart = computed(() => {
    const hasScoreChart = !!this.evaluationScale();
    const hasSkillsChart = !!this.summary().skills;

    return hasScoreChart !== hasSkillsChart;
  });

  public summary = input.required<AggregatedEvaluationsSummary>();
  public evaluationScale = input<RatingScale | null>(null);
  public theme = input<Theme | null>(null);
  public canReveal = input(false);

  public revealForMe = output();
}
